import { FC } from 'react';
import { observer } from 'mobx-react';
import { generatePath, Link } from 'react-router-dom';
import { Button, Stack } from '@servicetitan/design-system';
import { ITenant } from '@servicetitan/marketing-tenant-management-api';
import { withRoot } from '../../../utils/with-root';
import { AccountManagementRoutes } from '../../../utils/routes';
import { TableCellDataProps } from '../../../../common/utils/types';

export const ActionsCell: FC<TableCellDataProps<ITenant>> = observer(
    ({ style, colSpan, className, ariaColumnIndex, dataItem }) => {
        const relativePath = generatePath(AccountManagementRoutes.manageTenant, {
            externalPartnerId: dataItem.partnerId,
            externalTenantId: dataItem.externalId,
        });

        return (
            <td
                colSpan={colSpan}
                style={{ ...style }}
                className={className}
                aria-colindex={ariaColumnIndex}
            >
                <Stack justifyContent="center">
                    <Link to={withRoot(relativePath)}>
                        <Button size="xsmall">Manage</Button>
                    </Link>
                </Stack>
            </td>
        );
    },
);
